import React, { Fragment } from 'react'
import { useReactiveVar } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import { useCheckoutRouter } from '@src/hooks/useCheckoutRouter/useCheckoutRouter'
import { screenResolutionVar } from '@src/models/screenResolution'

import {
  ClearSearchButton,
  Header,
  HeaderContainer,
  NonIdealSearchContainer,
} from './MenuItemSearchResults.styles'

import { isFinalElementInBreakpoint } from '../isFinalElementInBreakpoint'
import { ItemsContainer, ItemContainer } from '../MenuGroup/MenuGroup.styles'
import { MenuItem } from '../MenuItem/MenuItem'
import { useOutletPageContext } from '../../OutletPageContext'

export const MenuItemSearchResults: React.VFC<{
  outletId: string
}> = ({ outletId }) => {
  const { width } = useReactiveVar(screenResolutionVar)
  const { displayPermanentCheckout } = useCheckoutRouter()

  const { t } = useTranslation('serviceNavigation')

  const {
    menuSearchIds,
    setMenuSearchIds,
    searchTerm,
    setSearchTerm,
    setShowMenuSearchResults,
  } = useOutletPageContext()

  return (
    <Fragment>
      <HeaderContainer>
        <Header>{t('search_results', { searchTerm: searchTerm })}</Header>
      </HeaderContainer>
      {menuSearchIds.length ? (
        <ItemsContainer>
          {menuSearchIds.map((menuItemId, index) => (
            <ItemContainer key={menuItemId}>
              <MenuItem
                showMenuThumbnails={true}
                outletId={outletId}
                menuItemId={menuItemId}
                finalElement={isFinalElementInBreakpoint(
                  menuSearchIds.length,
                  index,
                  width,
                  displayPermanentCheckout
                )}
              />
            </ItemContainer>
          ))}
        </ItemsContainer>
      ) : (
        <NonIdealSearchContainer>
          <div>{t('nothing_matches_search')}</div>
          <ClearSearchButton
            onClick={() => {
              setSearchTerm('')
              setMenuSearchIds([])
              setShowMenuSearchResults(false)
            }}
          >
            {t('show_everything')}
          </ClearSearchButton>
        </NonIdealSearchContainer>
      )}
    </Fragment>
  )
}
